<template>
  <div>
    <loader v-if="loading" />

    <b-row v-else>
      <b-col cols="12" md="6">
        <div class="white-container">
          <formFields
            :fields="fields"
            :label-block-with="3"
            :inline="true"
            :prefill-params="prefillParams"
            @submit="onSubmit"
          />
        </div>
      </b-col>
      <b-col md="6">
        <div class="mb-2 d-block">
          {{ $t('form.html') }}
          <span class="text-danger">
            {{ $t('form.required_star') }}
          </span>
        </div>
        <b-card body-class="p-0">
          <editor
            v-model="prefillParams.content"
            lang="html"
            theme="chrome"
            width="100%"
            height="500"
            @init="editorInit"
            @input="
              (value) => {
                prefillParams.content = value;
                paramsMutated.content = value;
              }
            "
          />
        </b-card>
        <span class="mb-2 d-block">
          {{ $t('form.preview') }}
        </span>
        <b-card body-class="p-0">
          <iframe :srcDoc="prefillParams.content" style="height: 500px" class="w-100" />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import wallkitPlansFields from './wallkitPlansFields';
import formFields from '@/components/global/formFields';
export default {
  name: 'WallkitPlanView',
  components: { formFields },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: wallkitPlansFields,
      prefillParams: {
        content: '',
        active: true,
        is_public: true,
      },
      paramsMutated: {},
      loading: false,
      planId: null,
    };
  },
  mounted() {
    this.planId = this.$route.params.id;
    if (this.editing && this.planId) {
      this.getPrefillParams();
    }
  },
  methods: {
    editorInit() {
      require('brace/mode/html');
      require('brace/theme/chrome');
    },
    async getPrefillParams() {
      this.loading = true;
      await this.getData(`pricing/plans/${this.planId}`)
        .then((resp) => {
          if (resp.data) {
            this.prefillParams = {
              ...resp.data,
              monthly_price: this.formatToDollars(resp.data.monthly_price),
              up_free_signups_price: this.formatToDollars(resp.data.up_free_signups_price),
              up_free_support_price_per_hour: this.formatToDollars(
                resp.data.up_free_support_price_per_hour,
              ),
              content: resp.data.content ? resp.data.content : '',
            };
          }
        })
        .catch((error) => {
          console.log('get prefill params error', error);
        });
      this.loading = false;
    },
    async updatePlan() {
      this.loading = true;
      await this.putData(`pricing/plans/${this.planId}`, {
        ...this.paramsMutated,
        monthly_price: this.formatToCents(this.paramsMutated.monthly_price),
        up_free_signups_price: this.formatToCents(this.paramsMutated.up_free_signups_price),
        up_free_support_price_per_hour: this.formatToCents(
          this.paramsMutated.up_free_support_price_per_hour,
        ),
      })
        .then(() => {
          this.prefillParams = this.paramsMutated;
        })
        .catch((error) => {
          console.log('update plan error', error);
        });
      this.loading = false;
    },
    async createNewPlan() {
      this.loading = true;
      await this.postData(
        `pricing/plans`,
        {
          ...this.paramsMutated,
          monthly_price: this.formatToCents(this.paramsMutated.monthly_price),
          up_free_signups_price: this.formatToCents(this.paramsMutated.up_free_signups_price),
          up_free_support_price_per_hour: this.formatToCents(
            this.paramsMutated.up_free_support_price_per_hour,
          ),
        },
        '/wallkit-pricing',
      ).catch((error) => {
        console.log('create new plan error', error);
      });

      this.loading = false;
    },
    onSubmit(params) {
      this.paramsMutated = params;
      if (this.editing) {
        this.updatePlan();
      } else {
        this.createNewPlan();
      }
    },
  },
};
</script>
